'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AsyncComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createLazyComponent = createLazyComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _LoadingView = require('./LoadingView');

var _LoadingView2 = _interopRequireDefault(_LoadingView);

var _LoadingFailedView = require('./LoadingFailedView');

var _LoadingFailedView2 = _interopRequireDefault(_LoadingFailedView);

var _enumify = require('enumify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingStatus = function (_Enum) {
    _inherits(LoadingStatus, _Enum);

    function LoadingStatus() {
        _classCallCheck(this, LoadingStatus);

        return _possibleConstructorReturn(this, (LoadingStatus.__proto__ || Object.getPrototypeOf(LoadingStatus)).apply(this, arguments));
    }

    return LoadingStatus;
}(_enumify.Enum);

LoadingStatus.initEnum(['LOADING', 'LOADED', 'FAILED']);

/**
 * @param getComponent - function that returns a promise for a component,
 * it will not be called until the first mount
 *
 * @returns {AsyncComponent}
 */
function createLazyComponent(getComponent, LoadingFailedView) {
    _auroraJavascriptUtils.assert.func(getComponent);
    return function () {
        return _react2.default.createElement(AsyncComponent, { getComponent: getComponent, LoadingFailedView: LoadingFailedView });
    };
}

var AsyncComponent = exports.AsyncComponent = function (_React$Component) {
    _inherits(AsyncComponent, _React$Component);

    function AsyncComponent(props) {
        _classCallCheck(this, AsyncComponent);

        var _this2 = _possibleConstructorReturn(this, (AsyncComponent.__proto__ || Object.getPrototypeOf(AsyncComponent)).call(this, props));

        _this2.state = {
            component: null,
            loadingStatus: LoadingStatus.LOADING
        };
        return _this2;
    }

    _createClass(AsyncComponent, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.mounted = false;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.mounted = true;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this3 = this;

            var getComponent = this.props.getComponent,
                readiness = this.context.readiness;


            if (readiness && this.state.component) {
                readiness.ready(this);
                return;
            }

            if (readiness) readiness.unready(this);

            // `.then(onSuccess, onError)` allows us to handle only the original
            // promise's errors
            getComponent().then(function (component) {
                if (_this3.mounted) {
                    _this3.setState({
                        component: component,
                        loadingStatus: LoadingStatus.LOADED
                    });
                }
                if (readiness) readiness.ready(_this3);
            }, function (err) {
                console.error('Async import error:', err);
                if (_this3.mounted) {
                    _this3.setState({
                        loadingStatus: LoadingStatus.FAILED
                    });
                }
                if (readiness) readiness.ready(_this3);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                loadingStatus = _state.loadingStatus,
                Component = _state.component;
            var _props = this.props,
                _props$LoadingFailedV = _props.LoadingFailedView,
                LoadingFailedView = _props$LoadingFailedV === undefined ? _LoadingFailedView2.default : _props$LoadingFailedV,
                _props$LoadingView = _props.LoadingView,
                LoadingView = _props$LoadingView === undefined ? _LoadingView2.default : _props$LoadingView;


            if (loadingStatus === LoadingStatus.LOADING) {
                return _react2.default.createElement(LoadingView, null);
            }

            if (loadingStatus === LoadingStatus.LOADED) {
                return _react2.default.createElement(Component, this.props);
            }

            if (loadingStatus === LoadingStatus.FAILED) {
                return _react2.default.createElement(LoadingFailedView, null);
            }

            throw Error('unknown loading status');
        }
    }]);

    return AsyncComponent;
}(_react2.default.Component);

AsyncComponent.propTypes = {
    getComponent: _propTypes2.default.func.isRequired,
    LoadingFailedView: _propTypes2.default.func
};

AsyncComponent.contextTypes = {
    readiness: _propTypes2.default.object
};


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/lazyComponent.js
// module id = 1326
// module chunks = 118